export default __webpack_public_path__ + "static/media/tpm_logo_colour.aafd82d9.svg";